
const INITIAL_STATE = {
    AllStudents: [],
    student: {},
    studentChallansDetails: []

};

const StudentReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'GET_ALL_STUDENT':
            return {
                ...state,
                AllStudents: action.payload
            };
        case 'GET_ONE_STUDENT':
            return {
                ...state,
                student: action.payload
            };
        case 'GET_STUDENT_CHALLANS':
            return {
                ...state,
                studentChallansDetails: action.payload.studentChallansDetails
            };

        default:
            return state;
    }
};

export default StudentReducer;
